export default __webpack_public_path__ + "static/media/noun_profile_2068277.1172d0d9.svg";